import React, { useEffect, useRef, useState } from "react";
import slidenext from "../../Assets/images/slide-next.svg";
import slideback from "../../Assets/images/slide-back.svg";
import { LanguageConstants } from "../../constants/LanguageConstants";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css"; // Import Owl Carousel CSS
import "owl.carousel/dist/assets/owl.theme.default.css"; // Import Owl Carousel Theme
import { getAverageRating } from "../../utils/Helper";
import userimage from "../../Assets/images/user.png";
import { Rating } from "@smastrom/react-rating";
import "@smastrom/react-rating/style.css";

import fillStart from "../../Assets/images/star.png";
import halfStart from "../../Assets/images/star-outline.png";

// @ts-ignore
import ReactStars from "react-rating-stars-component";
// @ts-ignore
import ReadMoreReadLess from "react-read-more-read-less";

function Testimonial(props: any) {
  const [data, setData] = useState([]);
  const carouselRef = useRef<OwlCarousel>(null); // Explicitly define the type
  const options = {
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      480: { items: 2 },
      768: { items: 3 },
      1199: { items: 5 },
    },
  };
  const handleButtonNextClick = () => {
    if (carouselRef.current && carouselRef.current.$ele) {
      carouselRef.current.next(50);
    }
  };
  const handleButtonBackClick = () => {
    if (carouselRef.current && carouselRef.current.$ele) {
      carouselRef.current.prev(50);
    }
  };

  useEffect(() => {
    if (props?.data) {
      setData(props?.data);
    }
  }, [props]);

  return (
    <>
      <section className="testimonials-sec">
        <div className="container">
          <div className="row">
            <div className="col-8">
              <h3 className="blue-heading">{LanguageConstants?.TESTIMONIAL}</h3>
            </div>
            <div className="col-4">
              <div className="d-flex justify-content-end gap-3">
                <div className="testi-arw testi-arw-left" id="testi-left">
                  <img
                    src={slideback}
                    alt="Previous"
                    onClick={handleButtonBackClick}
                  />
                </div>
                <div className="testi-arw testi-arw-rght" id="testi-right">
                  <img
                    src={slidenext}
                    alt="Next"
                    onClick={handleButtonNextClick}
                  />
                </div>
              </div>
            </div>
          </div>
          <h4 className="what-say">{LanguageConstants?.CLIENTREVIEW}</h4>
        </div>

        <div className="testimonial-slider" id="testimonial-slider">
          <div className="container">
            {data.length > 0 ? (
              <OwlCarousel className="owl-theme" {...options} ref={carouselRef}>
                {data.map((res: any, i: any) => (
                  <div className="item" key={i}>
                    <div className="testi-card item">
                      <div className="testi-name">
                        <div className="drop-img">
                          <img
                            className="testimonial_image"
                            src={
                              res?.user_details?.profile_pic
                                ? res?.user_details?.profile_pic
                                : userimage
                            }
                          />
                        </div>
                        {res?.user_details?.name
                          ? res?.user_details?.name
                              ?.split(" ")
                              ?.map((w: any, i: any) =>
                                i == 1 ? w[0] + "." : w
                              )
                              ?.join(" ")
                          : 
                          
                          res?.testimonial_details?.title
                              ?.split(" ")
                              ?.map((w: any, i: any) =>
                                i == 1 ? w[0] + "." : w
                              )
                              ?.join(" ")
                          }
                      </div>

                      <div className="testi-rating" style={{ display: "flex" }}>
                        {/* <div className="star-rating-new"> */}
                        {Array.from({ length: 6 }, (_, i) => (
                          <img
                            key={i}
                            src={
                              i < getAverageRating(res?.testimonial_details)
                                ? fillStart
                                : halfStart
                            }
                            alt={`Star ${i + 1}`}
                            style={{ width: 22, height: 22 , marginRight:'5px' }}
                          />
                        ))}
                        {/* </div> */}
                      </div>
                      <p className="testi-comment">
                        <ReadMoreReadLess
                          charLimit={
                            res?.testimonial_details?.content?.length > 20
                              ? 15
                              : 100
                          }
                          readMoreText=" Read More"
                          readLessText=" Read Less"
                          readMoreStyle={{
                            color: "rgb(90 50 199)",
                            fontWeight: "500",
                            cursor: "pointer",
                          }}
                          readLessStyle={{
                            color: "rgb(90 50 199)",
                            fontWeight: "500",
                            cursor: "pointer",
                          }}
                        >
                          {res?.testimonial_details?.content}
                        </ReadMoreReadLess>
                        {/* {res?.testimonial_details?.content} */}
                      </p>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonial;
